import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import './styles.css'
import { getHeaderdata } from './api'
import { setHeader } from '../Banner/headerreducer'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
function Banner () {
  // Variables declaration
  const bannerdata = useSelector(state => state?.headerreducer?.bannerdata)
  const dispatch = useDispatch()
  const [headerdata, setHeaderdata] = useState([])
  const [index, setIndex] = useState(0)
  const [currentPosition, setCurrentPosition] = useState(0)
  // end of variables declaration
  //   Use Effect portion
  React.useEffect(() => {
    if (bannerdata?.length > 0) {
      setHeaderdata(bannerdata)
      return
    }
    getHeaderdata.getBanner((err, data) => {
      if (err) {
      } else {
        dispatch(setHeader(data?.data?.data))
        setHeaderdata(data?.data?.data)
      }
    })
  }, [])

  // End of Use Effect portion
  return (
    <section class='main-banner'>
      <div class='overlay'>
        <div class='container-fluid px-0'>
          <div class='row'>
            <div
              id='ex-main-carousel'
              class='carousel slide'
              data-bs-ride='carousel'
              data-bs-interval='false'
              onMouseDown={e => {
                let details = window?.navigator.userAgent
                let regexp = /android|iphone|kindle|ipad/i

                /* Using test() method to search regexp in details
                it returns boolean value*/
                let isMobileDevice = regexp.test(details)

                if (!isMobileDevice) {
                  return
                }
                setCurrentPosition(e.pageX)
              }}
              onMouseUp={e => {
                let details = window?.navigator.userAgent
                let regexp = /android|iphone|kindle|ipad/i

                /* Using test() method to search regexp in details
                it returns boolean value*/
                let isMobileDevice = regexp.test(details)

                if (!isMobileDevice) {
                  return
                }
                if (e.pageX < currentPosition) {
                  if (index > 0) {
                    setIndex(index - 1)
                    document?.getElementById('prev')?.click()
                  }
                  console.log('left')
                } else if (e.pageX > currentPosition) {
                  console.log('Right')
                  if (headerdata?.length > index + 1) {
                    setIndex(index + 1)
                    document?.getElementById('next')?.click()
                  }
                }
              }}
              onTouchStart={e => {
                // alert("I am Awais Niaz touch")
                // alert(e.touches[0].clientX)
                let details = window?.navigator.userAgent
                let regexp = /android|iphone|kindle|ipad/i

                /* Using test() method to search regexp in details
                it returns boolean value*/
                let isMobileDevice = regexp.test(details)

                if (!isMobileDevice) {
                  return
                }
                console.log(e.touches[0].clientX)
                setCurrentPosition(e.touches[0].clientX)
              }}
              onTouchMove={e => {
                // alert("I am Awais Niaz touch 2")
                let details = window?.navigator.userAgent
                let regexp = /android|iphone|kindle|ipad/i

                /* Using test() method to search regexp in details
                it returns boolean value*/
                let isMobileDevice = regexp.test(details)

                if (!isMobileDevice) {
                  return
                }
                console.log(e.touches[0].clientX)

                // alert(e.originalEvent?.touches[0].pageX)
                // console.log(e.originalEvent.touches[0].pageX)
                if (e.touches[0].clientX < currentPosition) {
                  if (index > 0) {
                    setIndex(index - 1)
                    document?.getElementById('prev')?.click()
                  }
                  console.log('left')
                } else if (e.pageX > currentPosition) {
                  console.log('Right')
                  if (headerdata?.length > index + 1) {
                    setIndex(index + 1)
                    document?.getElementById('next')?.click()
                  }
                }
              }}
            >
              {headerdata?.length > 1 ? (
                <div class='carousel-indicators d-md-none'>
                  {headerdata?.map((i, ind) => {
                    return (
                      <button
                        type='button'
                        data-bs-target='#ex-main-carousel'
                        data-bs-slide-to={ind}
                        class={index == ind ? 'active' : ''}
                        aria-current='true'
                        aria-label='Slide 1'
                        onClick={() => {
                          setIndex(ind)
                        }}
                      ></button>
                    )
                  })}
                </div>
              ) : null}
              <div class='carousel-inner'>
                {headerdata?.map((item, i) => {
                  return (
                    <>
                      {headerdata?.length > 1 ? (
                        <button
                          id='prev'
                          data-bs-target='#ex-main-carousel'
                          class='carousel-control-prev carousel-btn d-none d-md-block prev-btn'
                          type='button'
                          // disabled={slide == 1 ? true : false}
                          data-bs-slide='prev'
                          onClick={e => {
                            // if (slide > 0) {
                            e.target.disabled = true
                            setTimeout(() => {
                              e.target.disabled = false
                            }, 1000)
                            setIndex(index - 1)
                            // 	setSlider(slide - 1)
                            // }
                          }}
                        >
                          <span
                            class='carousel-control-prev-icon'
                            aria-hidden='true'
                          ></span>
                        </button>
                      ) : null}
                      <div
                        class={`carousel-item ${index == i ? 'active' : ''}`}
                        key={`banner${i}`}
                      >
                        <img
                          fetchpriority={i == 0 ? 'high' : 'low'}
                          src={item?.image}
                          alt='carousel-img'
                        />
                        <div class='carousel-caption'>
                          {/* <div class="caption-title">
											NFT platform
										</div> */}
                          {item?.title != null ? (
                            <h1 className='titleHeader'>
                              {/* Digital <br /> Collectibles <br /> For Sports */}
                              {item?.title}
                            </h1>
                          ) : null}
                          {item?.btn_link != null && item?.btn_title != null ? (
                            item?.btn_link?.includes('http') ||
                            item?.btn_link?.includes('https') ? (
                              <a
                                href={item?.btn_link}
                                target={item?.target}
                                className='btn btnm-primary'
                              >
                                {item?.btn_title}
                              </a>
                            ) : (
                              <Link
                                to={item?.btn_link}
                                class='btn btnm-primary'
                                id='gotoplace'
                              >
                                {item?.btn_title}
                              </Link>
                            )
                          ) : null}
                        </div>
                      </div>
                      {headerdata?.length > 1 ? (
                        <button
                          data-bs-target='#ex-main-carousel'
                          class='carousel-control-next carousel-btn d-none d-md-block  next-btn'
                          id='next'
                          type='button'
                          data-bs-slide='next'
                          // disabled={headerdata?.length > slide ? false : true}
                          onClick={e => {
                            // alert(index)
                            // if (headerdata?.length > slide) {
                            e.target.disabled = true
                            setTimeout(() => {
                              e.target.disabled = false
                            }, 1000)
                            setIndex(index + 1)
                            // 	setSlider(slide + 1)
                            // }
                          }}
                        >
                          <span
                            class='carousel-control-next-icon'
                            aria-hidden='true'
                          ></span>
                        </button>
                      ) : null}
                    </>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Banner
